import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fonts.din2014Regular,
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    minHeight: '342px',
  },
  headerContainer: {
    maxHeight: '64px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '24px',
  },
  header: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
    width: '100%',
  },
  xMarkIcon: {
    fill: colors.tertiaryIcon,
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    marginTop: '4px',
  },
  contentWrapper: {
    display: 'flex',
    padding: '0px 24px',
    flexDirection: 'column',
    gap: anatomy['space-16'],
  },
  phoneInputWrapper: {
    marginBottom: '16px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: anatomy['space-8'],
    padding: '16px 24px',
  },
});
